export default __webpack_public_path__ + "static/media/a3.f39c762e.jpg";